module.exports = __webpack_public_path__ + "img/emprendimiento-comunitario.f432845d.jpeg";